<template>
    <div class="templete_box">
        <div class="templete">
            <div class="search_box search_box_f clearfix">
                <el-input class="search_select search_inputBox" v-model="params.bale_no" placeholder="捆包号" size="mini"></el-input>
                <el-select class="search_select search_inputBox" v-model="params.breed_id" multiple collapse-tags placeholder="品名" @visible-change="getSelectCheckRecord('breed_id')">
                    <el-option v-for="list in selectMapT.breed_id" :key="list.id" :value="list.id" :label="list.name"></el-option>
                </el-select>
                <el-select class="search_select search_inputBox" v-model="params.brand_id" multiple collapse-tags placeholder="品牌" @visible-change="getSelectCheckRecord('brand_id')">
                    <el-option v-for="list in selectMapT.brand_id" :key="list.id" :value="list.id" :label="list.name"></el-option>
                </el-select>
                <el-select class="search_select search_inputBox" v-model="params.grade_id" placeholder="等级" multiple @visible-change="getSelectCheckRecord('grade_id')">
                    <el-option v-for="list in selectMapT.grade_id" :key="list.id" :value="list.id" :label="list.name"></el-option>
                </el-select>
                <el-select class="search_select search_inputBox" v-model="params.index_thickness" multiple collapse-tags placeholder="厚度" @visible-change="getSelectCheckRecord('index_thickness')">
                    <el-option v-for="list in selectMapT.index_thickness" :key="list.id" :value="list.id" :label="list.name"></el-option>
                </el-select>
                <!-- <el-select class="search_select search_inputBox" v-model="params.index_thickness" multiple collapse-tags placeholder="厚度" @visible-change="getSelectCheckRecord('index_thickness')">
                    <el-option v-for="list in selectMapT.index_thickness" :key="list.id" :value="list.id" :label="list.name"></el-option>
                </el-select> -->
                <el-select class="search_select search_inputBox" v-model="params.index_length" multiple collapse-tags placeholder="长度" @visible-change="getSelectCheckRecord('index_length')">
                    <el-option v-for="list in selectMapT.index_length" :key="list.id" :value="list.id" :label="list.name"></el-option>
                </el-select>
                <el-select class="search_select search_inputBox" v-model="params.status" multiple collapse-tags placeholder="盘点状态" @visible-change="getSelectCheckRecord('status')">
                    <el-option v-for="list in selectMapT.status" :key="list.id" :value="list.id" :label="list.name"></el-option>
                </el-select>
                <el-select class="search_select search_inputBox" v-model="params.types" multiple collapse-tags placeholder="盘点方式" @visible-change="getSelectCheckRecord('types')">
                    <el-option v-for="list in selectMapT.types" :key="list.id" :value="list.id" :label="list.name"></el-option>
                </el-select>
                <el-select class="search_select search_inputBox" v-if="isShowMore" v-model="params.checker_id" multiple collapse-tags placeholder="盘点人" @visible-change="getSelectCheckRecord('checker_id')">
                    <el-option v-for="list in selectMapT.checker_id" :key="list.id" :value="list.id" :label="list.name"></el-option>
                </el-select>
                <el-select class="search_select search_inputBox" v-if="isShowMore" v-model="params.thumbnail" placeholder="图片状态" multiple @visible-change="getSelectCheckRecord('thumbnail')">
                    <el-option v-for="list in selectMapT.thumbnail" :key="list.id" :value="list.id" :label="list.name"></el-option>
                </el-select>
                <div class="searchBtnList clearfix">
                    <div class="reset fcolor" @click="isShowMore=!isShowMore">{{isShowMore?'收起':'更多'}}</div>
                    <div class="reset fcolor" @click="resetSearch">重置</div>
                    <el-button  class="publicBtn" @click="getList(true)">查询</el-button>
                </div>
                <div class="execlInsert execlInsertHasFilter clearfix">
                    <div class="filterBtn" @click="filterDialogVisible=!filterDialogVisible"></div>
                    <span class="excel_btn" @click="excelExport"><i class="excel-icon"></i>excel导出</span>
                </div>
            </div>
            <div class="tableBox">
                <tabletem :isSetCol="true" scene="inventory.check.logs.details" :isLoading="tableLoading" @rowClick="rowClick" :tablecol="tableCol" :tabledata="list"></tabletem>
            </div>
            <div class="totalCal no_print">
                <div class="totalName">合计：</div>
                <div class="totalNumber">盘点件数: <span :style="totalObj.check_number > totalObj.wait_number?'color: green': totalObj.check_number<totalObj.wait_number?'color: red':''">{{totalObj.check_number}}</span>/{{totalObj.wait_number}}</div>
            </div>
            <div class="pageBox">
                <pagination ref="pagination" :lastpages.sync="last_page" :currentpages.sync="params.page" :all.sync="total" :pagesizes.sync="params.per_page" @getPage="getPage"></pagination>
            </div>
        </div>
        <!-- 字段过滤 START -->
        <filter-fields :tableData="filter" scene="inventory.check.logs.details" :filterDialogVisible="filterDialogVisible" @confirm="filterConfirm" @dialogChangeFunc="val=>{this.filterDialogVisible = val;}"></filter-fields>
        <!-- 字段过滤 END -->
    </div>
</template>
<style scoped lang="scss">
</style>
<script>
    import pagination from '../../components/pagination.vue'
    import tabletem from '../../components/table.vue'
    export default {
        components:{
            pagination,
            tabletem
        },
        data(){
            return{
                tableLoading:false,
                id:'',
                module:localStorage.dw_erp_power_code,
                isShowMore:false,
                params:{
                    bale_no:'',
                    brand_id:[],
                    breed_id:[],
                    grade_id:[],
                    index_thickness:[],
                    index_length:[],
                    status:[],
                    types:[],
                    checker_id:[],
                    thumbnail:[],
                    per_page: 50,
                    page:1
                },
                totalObj:{},
                // start_time:"",
                // end_time:"",
                last_page: 1,
                current_page: 1,
                total: 0,
                updataType:2,//2新增，3修改
                list : [],
                proList:[],
                cityList:[],
                searchCityList:[],
                selectMap:{
                    user:[],
                },
                selectMapT:{
                    sales_length:[],
                    sales_thickness:[],
                    status:[],
                    bale_status:[],
                    brand_id:[],
                    breed_id:[],
                    supplier_id:[],
                    grade_id:[],
                    color_id:[],
                    warehouse_id:[]
                },
                // dialog
                dialogVisible : false,
                filterDialogVisible:false,
                filter:"",
                fields:"",
                tableCol:[	
                    {colName:"捆包号",colKey:"bale_no",colWidth:120,isSetWidth:true,isCanClick:false,isColor:true,isShow:true},
                    {colName:"品名",colKey:"breed",colWidth:90,isSetWidth:true,isCanClick:false,isColor:true,isShow:true},
                    {colName:"品牌",colKey:"brand",colWidth:90,isSetWidth:true,isCanClick:false,isColor:true,isShow:true},
                    {colName:"等级",colKey:"grade",colWidth:90,isSetWidth:true,isCanClick:false,isColor:true,isShow:true},
                    {colName:"厚度",colKey:"index_thickness",colWidth:90,isSetWidth:true,isCanClick:false,isColor:true,isShow:true},
                    {colName:"长度",colKey:"index_length",colWidth:90,isSetWidth:true,isCanClick:false,isColor:true,isShow:true},
                    {colName:"销售方数",colKey:"sales_cube",colWidth:90,isSetWidth:true,isCanClick:false,isColor:true,isShow:true},
                    {colName:"仓库",colKey:"warehouse",colWidth:90,isSetWidth:true,isCanClick:false,isColor:true,isShow:true},
                    {colName:"盘点状态",colKey:"status_text",colWidth:90,isSetWidth:true,isCanClick:false,isColor:true,isShow:true}, 
                    {colName:"盘点类型",colKey:"types_text",colWidth:90,isSetWidth:true,isCanClick:false,isColor:true,isShow:true},
                    {colName:"盘点人",colKey:"checker_name",colWidth:90,isSetWidth:true,isCanClick:false,isColor:true,isShow:true},
                    {colName:"图片状态",colKey:"photo_text",colWidth:90,isSetWidth:true,isCanClick:false,isColor:true,isShow:true},
                ],
                warehouseList:[],
                creatorList:[],
                checkerList:[],
            }
        },
        created(){
            if(sessionStorage.Record_ID){
                this.id=sessionStorage.Record_ID;
                this.tableColCopy = this.$deepClone(this.tableCol);
                this.getList();
                sessionStorage.removeItem("Record_ID")
            }
            this.getSelectCheckRecord("thumbnail");
            this.getSelectCheckRecord("index_thickness");
            this.getSelectCheckRecord("index_length");
            this.getSelectCheckRecord("checker_id");
            this.getSelectCheckRecord("types");
            this.getSelectCheckRecord("status");
        },
        mounted(){
        },
        methods:{
            excelExport(){
                this.$exportExecl("/erp/inventory.check.details.export","盘点记录",this.params)
            },
            getSelectCheckRecord(target){
                this.$getSelectCheckRecord(target,{check_id:Number(this.id),breed_id:this.params.breed_id,breed_id:this.params.breed_id,
                grade_id:this.params.grade_id,index_thickness:this.params.index_thickness,index_length:this.params.index_length,
                status:this.params.status,types:this.params.types,checker_id:this.params.checker_id,thumbnail:this.params.thumbnail}).then(res=>{
                    this.selectMapT[res.data.data.target]=res.data.data.result;
                })
            },
            filterConfirm(){
                this.getList()
            },
            getList(flag){
                if(flag){
                    this.params.page = 1;
                }
                // this.params.start_time = this.formatTimeZero(this.start_time)
                // this.params.end_time = this.formatTimeZero(this.end_time)
                this.tableLoading = true;
                this.params.check_id = Number(this.id);
                this.$postColumnList("/erp/inventory.check.logs.details",this.params,res=>{
                    this.pl(res)
                    this.last_page=parseInt(res.data.data.list.last_page);
                    this.totalObj = res.data.data.total;
                    // this.params.page=parseInt(res.data.data.current_page);
                    this.$refs.pagination.flag = true;
                    this.tableLoading = false;
                    this.total=parseInt(res.data.data.list.total);
                    this.list=res.data.data.list.data;
                    this.list.forEach((item,index)=>{
                        if(item.check_date!=0){
                            this.list[index].check_date = this.formatTime(item.check_date+"000")
                        }else{
                            this.list[index].check_date = "";
                        }
                        if(item.check_id){
                            item.check_id = '查看详情'
                        }
                        if(item.status_text=='未盘'){
                            this.list[index].baseColor="#ff0000";
                        }else{
                            this.list[index].baseColor="";
                        }
                    })
                    this.filter = res.data.data.column;
                    this.fields=","+(res.data.data.fields.join(",")).toString()+",";
                    this.tableCol.forEach(item=>{
                        if(this.fields.indexOf(","+item.colKey+",")!=-1){
                            item.isShow=true;
                        }else{
                            item.isShow=false;
                        }
                    })
                },error=>{
                    this.tip(error.data.message,"warning")
                })
            },
            rowClick(obj){
                if(obj.name==='check_sn'){
                    this.$root.$children[0].$children[0].showTab({
                        label: "盘点记录",
                        name: "盘点记录",
                        content: "warehouseRecord",
                    });
                }
            },
            resetSearch(){
                this.params = this.params = {
                    bale_no:'',
                    brand_id:[],
                    breed_id:[],
                    grade_id:[],
                    index_thickness:[],
                    index_length:[],
                    status:[],
                    types:[],
                    checker_id:[],
                    thumbnail:[],
                    per_page: 50,
                    page:1
                }
                this.getSelectCheckRecord("thumbnail");
                this.getSelectCheckRecord("index_thickness");
                this.getSelectCheckRecord("index_length");
                this.getSelectCheckRecord("checker_id");
                this.getSelectCheckRecord("types");
                this.getSelectCheckRecord("status");
                this.getList()
            },
            getPage(obj){
                this.params.page = obj.currentpage;
                this.params.per_page = obj.pagesize;
            },
        },
        watch:{
            dialogVisible:function(val){
                if(!val){
                    this.form_params = this.resetJson(this.form_params)
                }
            },
            "params.page":function(){
                this.getList();
            },
            "params.per_page":function(){
                this.getList();
            }
        }
    }
</script>
